import { signOut } from 'next-auth/react';
import { useCallback } from 'react';
import { clearSelectedOrganisation } from '@/utils/storage';
import { PUBLIC_ROUTES } from '@/configs/routes';
import { SELECTED_ORG_ID } from '@/configs/storageKeys';
import { logError } from '@/lib/logger';

export function useLogout() {
  const logout = useCallback(async () => {
    try {
      clearSelectedOrganisation();
      sessionStorage.clear();
      localStorage.removeItem(SELECTED_ORG_ID);
      await signOut({ callbackUrl: PUBLIC_ROUTES.HOME });
    } catch (error) {
      logError('[Auth] Logout error:', error);
      window.location.href = PUBLIC_ROUTES.HOME;
    }
  }, []);

  return { logout };
}
